import React, { useContext, useEffect, useState } from "react";
import { useRouteMatch } from "react-router";
import { BackendContext } from "../../../services/backend-context";
import { Note } from "../../../types/types";
import styles from "./SingleNote.module.css";

interface Props {
    notes: Note[];
    onNoteSaved(): void;
}
export function SingleNote({ notes, onNoteSaved }: Props) {

    const route = useRouteMatch<{userId: string, noteId: string}>();
    const backendConfig = useContext(BackendContext);
    
    const editing = route.params.noteId === undefined;
    const [noteState, setNoteState] = useState<Partial<Note>>({ 
        title: "", 
        content: "" 
    });

    useEffect(() => {
        const note = notes.find(note => note.noteId === route.params.noteId);
        setNoteState(note 
            ? { ...note } 
            : { title: "", content: "" })
    }, [ notes, route.params.noteId ])

    const onSaveNote = async () => {
        await fetch(`${backendConfig.backend}/users/${route.params.userId}/notes`, { 
            method: "POST",
            body: JSON.stringify(noteState),
            headers: { "Content-Type": "application/json" }
        }).then(resp => resp.json())
        onNoteSaved();
    }

    const onTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNoteState(old => ({ ...old, title: e.target.value }))
    }

    const onContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNoteState(old => ({ ...old, content: e.target.value }))
    }

    return (
        <div className={ styles.container }>
            { !noteState && !editing
                ? <h1>This note does not exist</h1>
                : (
                    <header>
                        <label>
                            Title: 
                            <input disabled={ !editing } 
                                   value={ noteState.title }
                                   onChange={ onTitleChange } />
                        </label>
                    </header>
                )
            }
            <label htmlFor="note-content" className={ styles.noteContentLabel }>
                Note:
            </label>
            <textarea disabled={ !editing } 
                      id="note-content"
                      value={ noteState.content }
                      onChange={ onContentChange } />
            <button className={ styles.saveButton } onClick={ onSaveNote }>
                Save
            </button>
        </div>
    )
}